import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const planhat = defineConnector({
  identifier: "planhat",
  name: "Planhat",
  tagLine: "Customer success platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ host }) =>
    host ? domainToRegex(host) : "https://api[a-z0-9-]*\\.planhat\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an API access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Planhat, open **Settings > Private Apps** (previously called Service Accounts) and generate an API access token.",
        },
      ],
    },
    {
      title: "Enter your API host and access token",
      items: [
        {
          kind: "hostname",
          label: "API host",
          required: true,
          placeholder: "api.planhat.com",
          target: { kind: "configuration", field: "host" },
          helperText:
            "Planhat serves each tenant from a cluster: if you sign in at app-eu3.planhat.com, your API host is api-eu3.planhat.com.",
        },
        {
          kind: "input",
          label: "API access token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/companies?limit=1`,
  },
});
